// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getFirestore } from "firebase/firestore";


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC2K8wUudCiGcTqgg-lBy7GaCPe6qVspCk",
  authDomain: "mnist-mnesta-prd.firebaseapp.com",
  projectId: "mnist-mnesta-prd",
  storageBucket: "mnist-mnesta-prd.firebasestorage.app",
  messagingSenderId: "172799809716",
  appId: "1:172799809716:web:0d3e69b19a1e0345509fe1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app, "gastro-abst");